<template>
    <div class="sas-dashboard-container" v-loading="loading">
        <div id="chart3" class="section-chart-container-3" ref="chart3">
            <div class="chart3-egs">
                <div class="eg-item">
                    <div ref="egGreen" class="eg-color eg-color-green"></div>
                    <div class="eg-text">{{ $t('sas_dashboard_examples_14') }}</div>
                </div>
                <div class="eg-item">
                    <div ref="egGray" class="eg-color eg-color-gray"></div>
                    <div class="eg-text">{{ $t('sas_dashboard_examples_23') }}</div>
                </div>
            </div>
           
            <el-table
                :data="tableData" 
                :cell-style="chart3CellStyle"
                :row-style="{ height: '44px' }"
                max-height="320"
                :fit="true"
                :empty-text="$t('TABLE_NO_DATA')"
            >
                <el-table-column fixed width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="chart3-entity-name-inner" v-html="scope.row.entityName"></span>    
                    </template>
                </el-table-column>
                <el-table-column
                    :label="chart3Level1Label"
                    align="center">
                    <el-table-column
                        v-for="(v, k) in chart3Level2Columns"
                        :key="k"
                        :column-key="v.id"
                        :label="v.milestoneName"
                        >
                        <template #header>
                            <el-tooltip placement="top" effect="light">
                                <div slot="content" v-html="v.milestoneName"></div>
                                <div class="chart3-header-outer">
                                    <span class="chart3-header-inner" v-html="v.milestoneName"></span>    
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import * as _ from 'lodash'
import * as echarts from 'echarts'



export default {
    name: 'ExecutiveDashboard',
    props: {
        filterChange: {
            type: Function,
            default: () => {}
        },
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
            getShowMenuCodeList: 'getShowMenuCodeList',
            getIfKpHasAccess: 'getIfKpHasAccess',
        }),
        milestoneQueryList() {
            let milestoneQueryList = []
            this.tableColumns.forEach(v => {
                v.childMilestoneBO.forEach(vv => {
                    if (vv.where.status === 0 && vv.where.targetTime === null && vv.where.targetTimeFilter.filter(v => !!v).length != 2) return
                    let where = { milestoneId: vv.id }
                    if (vv.where.status !== 0) {
                        where.status = vv.where.status
                    }
                    if (vv.where.targetTimeFilter.filter(v => !!v).length == 2) {
                        where.targetTime = vv.where.targetTimeFilter
                    }
                    milestoneQueryList.push(where)
                })
            })
            return milestoneQueryList
        },
        tableFilter() {
            return {
                siteId: this.getSite.siteId,
                pageSize: this.limit,
                pageNum: this.page,
                entityId: this.getEntityIds,
                milestoneQueryList: this.milestoneQueryList,
                fileName: this.fileName
            }
        },
        chart3Level1Label() {
            const find = this.cascaderOptions3.find(v => v.id == this.dashboardMilestoneId3)
            if (find && find.milestoneName) {
                return find.milestoneName
            } else {
                return ''
            }
        },
        chart3Level2Columns() {
            // return this.cascaderOptions3.reduce((pre, cur) => {
            //     pre = [...pre, ...cur.childMilestoneBO]
            //     return pre
            // }, [])
            const find = this.cascaderOptions3.find(v => v.id == this.dashboardMilestoneId3)
            if (find && find.childMilestoneBO && find.childMilestoneBO.length > 0) {
                return find.childMilestoneBO
            } else {
                return []
            }
        },
    },
    data() {return {
        tableColumns: [],
        tableData:[],
        show: false,
        loading: false,
        dashboardMilestoneId3: [],
        cascaderOptions3:[],
        statsData0Sort: [],
        chart3ShowEntityTooltip: {},
        exportLoading: false,
        page: 1,
        limit: 10,
        fileName:'',
    }},
    methods: {
        
        chart3CellStyle({row, column, rowIndex, columnIndex}) {
            if (columnIndex == 0) {
                return { backgroundColor: 'white', height: '44px' }    
            }
            const cellColumn = this.chart3Level2Columns[columnIndex - 1]
            const find = row.mileStoneRecordList.find(vv => vv.milestoneId == cellColumn.id)
            let color = ''
            if (find && find.state) {
                color = [1, 4].includes(find.state) ? '#addec6' : ([2, 3].includes(find.state) ? '#e1e3e6' : 'white')
            } else {
                color = 'white'
            }
            return { backgroundColor: color, height: '44px' }
        },
        getStatsData0Sort() {
            this.statsData0Sort = Object.keys(this.statsData[0])
                    .sort((a, b) => Date.parse(new Date(a)) - Date.parse(new Date(b)))
                    .map(k => ({
                        date: `${k}`,
                        value: this.statsData[0][k]
                    }))
        },
        getData() {
            this.loading = true
            API.status.getStatusList({
                ...this.tableFilter,
                pageSize: 9999999,
                pageNum: 1
            }).then(res => {
                if (res.code == '1') {
                     
                    if (res.data && res.data.records && res.data.records.length > 0) {
                        res.data.records.forEach(v => {
                            this.chart3ShowEntityTooltip[v.id] = false
                            this.tableData.push(v)
                        })
                        this.test = res.data.records;
                    } else {
                        this.tableData = []
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => { console.error(e); }).finally(() => {
                this.loading = false
            })
            
        },
        async getTableColumn() {
            /**
             * 获取折叠列
             */
            const { code: code1, data: data1 } = await API.common.queryFixColumns({
                siteId: this.getSite.siteId,
                tableKey: 'SAS_collapse'
            })
            let collapseColumns = []
            if (code1 == '1' && data1 && data1.hiddenColumns && data1.hiddenColumns.length > 0) {
                collapseColumns = data1.hiddenColumns.replace('[', '').replace(']', '').split(', ').map(v => `${v}`)
            }

            /**
             * 获取表头
             *
             */
            const {code, data} = await API.status.listTableColumn({ siteId: this.getSite.siteId })
            if (code !== '1') {
                this.$message({
                    type: 'error',
                    message: this.$t(code)
                })
                return
            }
           

            this.tableColumns = data.map(v => {
                v.collapse = !!collapseColumns.includes(v.id)
                v.show = true
                v.childMilestoneBO = v.childMilestoneBO.map((vv, kk) => {
                    vv.showTableColumnTooltip = false
                    vv.show = true
                    vv.where = {
                        status: 0,
                        targetTime: null,
                        targetTimeFilter: ['', '']
                    }
                    return vv
                })
                return v
            })
        },
        initData() {
            // 三个下拉都塞上第一个元素
            function noDisable(val) {
                val.forEach(v => {
                    v.disabled = false
                    if (v.childMilestoneBO && v.childMilestoneBO.length > 0) {
                        v.childMilestoneBO.forEach(vv => vv.disabled = false)
                    }
                })
                return val
            }
           
            if (this.cascaderOptions3.length == 0) this.cascaderOptions3 = noDisable(_.cloneDeep(this.tableColumns))
           
            if (this.dashboardMilestoneId3.length == 0) {
                if(this.tableColumns[0]&&this.tableColumns[0].id){
                this.dashboardMilestoneId3 = this.tableColumns[0].id

                }
            }
            
            this.getData()
        },
    },
   
    async mounted(){
        if(!this.getShowMenuCodeList.includes('client002')) return
        await this.getTableColumn()
        if (this.getIfKpHasAccess) {
            await this.initData()
        }
    }
}
</script>
<style scoped>
.sas-dashboard-container {
    height: calc(100% - 50px);
    overflow: auto;
}
.slider-btn {
    position: fixed;
    top: 340px;
    right: 0;
    width: 40px;
    height: 40px;
    font-size: 22px;
    text-align: center;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    transition: right .3s cubic-bezier(.9, 0, .3, .7);
    pointer-events: auto;
    color: #ffff;
    background: #7213ea; 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2001;
}
.history-icon {
    position: absolute;
    width: 22px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}
::v-deep .el-drawer__header {
    border-bottom: solid 1px #eaebec;
    padding-bottom: 20px;
}
.sas-dashboard-container .body {
    width: 100%;
    overflow-x: hidden;
}
.draw-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.draw-title .draw-title-text {
    font-size: 15px;
    font-weight: 700;
    color: #263349;
}
.draw-title .draw-title-export-btn {
    margin-right: 20px;
}
.draw-body {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.draw-body .draw-section-title {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.draw-body .draw-section-title .section-title-text {
    margin-left: 15px;
    border-left: solid 5px #3879eb;
    padding-left: 10px;
    font-size: 13px;
    font-weight: 600;
}
.draw-body .draw-section-title .section-title-cascader {
    margin-right: 15px;
    width: 50%;
}
::v-deep .el-cascader-node__label {
    font-size: 12px;
}
::v-deep .el-cascader-menu {
    width: 180px;
}
.draw-body .section-chart-container {
    width: 100%;
    height: 400px;
}
.draw-body .section-chart-container-3 {
    width: calc(100% - 20px);
    margin-left: 10px;
    margin-right: 10px;
}
::v-deep .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: none;
    border: solid 1px #ebeef5;
}
.chart3-entity-name-outer {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.chart3-entity-name-inner {}

.chart3-header-outer {
    width: 95px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.chart3-header-inner {}

.chart3-egs {
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.chart3-egs .eg-item {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.chart3-egs .eg-item:nth-of-type(1) {
    margin-right: 20px;
}
.chart3-egs .eg-item .eg-color {
    width: 25px;
    height: 15px;
}
.chart3-egs .eg-item .eg-color-green {
    background-color: #addec6;
}
.chart3-egs .eg-item .eg-color-gray {
    background-color: #e1e3e6;
}
.chart3-egs .eg-item .eg-text {
    margin-left: 5px;
    font-size: 10px;
}
.el-table__empty-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center; /* 确保文本居中 */
}
</style>